export default __webpack_public_path__ + "static/media/ic-animals-variety.89af502f.svg";